import React, { useState } from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  
  &:hover {
    color: #333;
  }
`;

const Title = styled.h2`
  margin-top: 0;
  color: #333;
  font-family: 'Cormorant Garamond', serif;
`;

const Description = styled.p`
  color: #666;
  margin: 1rem 0;
  line-height: 1.6;
`;

const AddressButton = styled.button`
  background: transparent;
  color: #666;
  padding: 0.5rem 1rem;
  border: 2px solid #eee;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 1rem;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    border-color: #333;
    color: #333;
  }
`;

const AddressContainer = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 4px;
  position: relative;
`;

const Address = styled.p`
  color: #333;
  margin: 0;
  white-space: pre-line;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  line-height: 1.6;
`;

const CopyButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: transparent;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0.5rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;

  &:hover {
    color: #333;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

const PurchaseButton = styled.button`
  background: ${props => props.purchased ? '#4CAF50' : '#333'};
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: ${props => props.purchased ? 'default' : 'pointer'};
  transition: background 0.3s ease;
  width: 100%;
  margin-top: 1rem;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    background: ${props => props.purchased ? '#4CAF50' : '#444'};
  }
`;

const PurchaseModal = ({ item, onClose, onPurchase }) => {
  const [showAddress, setShowAddress] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');

  const address = "160 W 24th St\nApt. 2k\nNew York, NY 10011";

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed to copy');
    }
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Title>{item.title}</Title>
        <Description>{item.description}</Description>
        
        <ButtonContainer>
          {!item.purchased && (
            <AddressButton onClick={() => setShowAddress(!showAddress)}>
              {showAddress ? 'Hide Shipping Address' : 'See Shipping Address'}
            </AddressButton>
          )}
          
          {showAddress && !item.purchased && (
            <AddressContainer>
              <Address>{address}</Address>
              <CopyButton onClick={handleCopyAddress}>
                {copySuccess || 'Copy'}
              </CopyButton>
            </AddressContainer>
          )}

          <PurchaseButton 
            onClick={() => !item.purchased && onPurchase(item.id)}
            purchased={item.purchased}
          >
            {item.purchased ? 'Already Purchased' : 'Mark as Purchased'}
          </PurchaseButton>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default PurchaseModal; 